import {CardText, CardActions} from "material-ui/Card"
import {Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import Button from "material-ui/RaisedButton"
import React from "react"
import SubmitIcon from "material-ui/svg-icons/action/verified-user"
import TextField from "material-ui/TextField"
import compose from "recompose/compose"
import {withRouter} from "react-router-dom"
import * as Util from "../common"
import _Error from "./Error"

const M = Util.intlMessages("view.RegisterView")
const EM = Util.intlMessages("view.RegisterView.error")
const Error = _Error(EM)

function RegisterRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {input, formErrors} = props
  return (
    <div>
      <form
        onSubmit={
          props.isSubmitAllowed ? props.submit : e => e.preventDefault()
        }
      >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={<M id="title" />} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <p>
            <M id="description" />
          </p>
          <div>
            <TextField
              name="email"
              floatingLabelText={<M id="field.email" />}
              value={props.email}
              onChange={input.setEmail}
            />
          </div>
          <div>
            <TextField
              name="password"
              floatingLabelText={<M id="field.password" />}
              type="password"
              value={props.password}
              onChange={input.setPassword}
            />
          </div>
          <div>
            <TextField
              name="password2"
              floatingLabelText={<M id="field.password2" />}
              type="password"
              value={props.password2}
              onChange={input.setPassword2}
            />
          </div>
          <div>
            <TextField
              name="errors"
              underlineShow={false}
              disabled={true}
              errorText={(formErrors || []).map((error, i) => (
                <Error key={i} error={error} />
              ))}
            />
          </div>
        </CardText>
        <CardActions>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!props.isSubmitAllowed}
            onClick={props.submit}
          />
        </CardActions>
        <CardText>
          <small>
            <Link style={{color: "inherit"}} to="/privacy">
              <M id="privacy" />
            </Link>
          </small>{" "}
        </CardText>
        <CardText>
          {props.request.state === "SUCCESS" ? <M id="success" /> : null}
        </CardText>
      </form>
    </div>
  )
}
export default compose(
  containers.authSignin.Register(),
  withRouter,
  containers.willReceiveProps(props => {
    if (props.request.state === "SUCCESS") {
      props.history.push("/")
    }
    // done loading, account doesn't exist (visit /start for an anon account first) OR account has an email/already registered
    if (props.auth !== undefined && (!props.auth || props.auth.email)) {
      props.history.replace("/")
    }
  }),
  Util.DumpProps,
)(RegisterRender)



// WEBPACK FOOTER //
// ./src/auth-signin/RegisterView.js